export default "__VITE_ASSET__e3bd1e4b__"